<template>

<div class="plan" :class="planClass" :data-current="builder.section">
  <div class="plan-inner">

    <div class="plan-section plan-section--horizontal" data-id="0">
      <div class="plan-parts">
        <div class="plan-part" v-for="index in 12" :key="index">
          <div class="plan-part-door"></div>
        </div>
      </div>
    </div>
  
    <template v-for="n in totalSections">
      <div class="plan-section" :data-id="n" @click.stop="setSection(n)" :class="{ 'plan-section--interactive' : isInteractive, 'plan-section--active' : builder.section == n, 'plan-section--complete' : isSectionValid(n), 'plan-section--valid' : n <= builder.currentItem.validSection, 'plan-section--horizontal' : isSectionHorizontal(n) }">
        <div class="plan-flag">
          <span>{{ n }}</span>
          <div class="plan-check"><svg class="icon"><use href="#check"></use></svg></div>
        </div>
        <div class="plan-wall plan-wall--left"></div>
        <div class="plan-wall plan-wall--right"></div>
        <div class="plan-wall plan-wall--top"></div>
        <div class="plan-wall plan-wall--bottom"></div>
        <div class="plan-measure"></div>
      </div>
    </template>
  
  </div>
</div>

</template>

<script setup>
  
var _ = require('lodash');
  
import { computed } from 'vue'

const props = defineProps([
  'item',
  'wallspace',
  'layout',
  'sections',
  'customClass',
  'interactive'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['setSection'])

const item = computed(() => {
  if (props.item && !_.isNull(props.item)) {
    return props.item;
  } else if (builder.currentItem && !_.isNull(builder.currentItem)) {
    return builder.currentItem;
  }
    console.log('null')
  return null;
})

const planClass = computed(() => {
  let str = '';
  let theItem = item.value;
  if (!_.isUndefined(props.layout) && props.layout.length) {
    if (theItem && !_.isNull(theItem.product)) {
      str += theItem.product.slug;
    }
    str += ' ' + props.layout;
    if (!_.isUndefined(props.wallspace) && props.wallspace.length) {
      str += ' ' + props.wallspace;
    }
    str += ' plan--all-step';
  } else {
    if (theItem && !_.isNull(theItem.product)) {
      str += theItem.product.slug + ' ' + theItem.productLayout.slug;
    }
    if (!_.isUndefined(props.wallspace) && props.wallspace.length) {
        str += ' ' + props.wallspace;
    } else if (!_.isUndefined(theItem.data.wallSpace)) {
      str += ' ' + theItem.data.wallSpace.slug
    } else if (_.isUndefined(theItem.data.wallSpace)) {
      str += ' plan--no-walls';
    }
    if (_.isUndefined(builder.steps[builder.step-1].hasSections) || (!_.isUndefined(builder.steps[builder.step-1].hasSections) && !builder.steps[builder.step-1].hasSections)) {
      str += ' plan--all-step';
    }
    if (totalSections == 1) {
      str += ' plan--one-section';
    }
  }
  if (!_.isUndefined(props.customClass) && props.customClass.length) {
    str += ' ' + props.customClass;
  }
  str += ' plan--step-' + builder.step;
  return str;
})

const totalSections = computed(() => {
  if (!_.isUndefined(props.sections) && props.sections) {
    return props.sections;
  } else {
    return builder.sectionMax;
  }
})

const isInteractive = computed(() => {
  if (!_.isUndefined(props.interactive) && !props.interactive) return false;
  if (totalSections.value > 1) {
    if (builder.step == builder.stepWithSections) {
      return true;
    }
  }
  return false;
})

function setSection(num) {
  if (totalSections.value > 1) {
    emit('setSection', num);
  }
}

function isSectionHorizontal(num) {
  if ((planClass.value.search('galley') == -1 && num == 2) || planClass.value.search('straight')  !== -1) {
    return true;
  }
  return false;
}

function isSectionValid(num) {
  if (!_.isUndefined(props.interactive) && !props.interactive) return false;
  if (builder.validation.results && !_.isUndefined(builder.validation.results[builder.stepWithSections-1]) && !_.isUndefined(builder.validation.results[builder.stepWithSections-1].sections) && !_.isUndefined(builder.validation.results[builder.stepWithSections-1].sections[num-1])) {
    if (builder.validation.results[builder.stepWithSections-1].sections[num-1].valid) {
      return true;
    }
  }
  return false;
}
</script>